import htmlEscapeCharacter from '@intercom/embercom-composer/lib/html-escape-character';
import Constants from '@intercom/embercom-composer/lib/constants';
import Em from 'ember';
function HTMLGenerator(text, entities, config) {
  this.text = text;
  this.entities = entities;
  this.buffer = '';
  this.index = 0;
  this.openTags = [];
  this.entitiesToReopen = [];
  this.target = !config || config.target === undefined ? 'editor' : config.target;
  this.shouldEscapeContent = !config || config.shouldEscapeContent === undefined ? true : config.shouldEscapeContent;
  this.significantWhitespace = !config || config.significantWhitespace === undefined ? true : config.significantWhitespace;
  this.lastCharWasNonBreakingSpace = false;
  let capitalizedTarget = Em.String.capitalize(this.target);
  this.openingHtmlProperty = `openingHtmlFor${capitalizedTarget}`;
  this.closingHtmlProperty = `closingHtmlFor${capitalizedTarget}`;
}
HTMLGenerator.prototype = {
  getHtml() {
    for (this.index; this.index < this.text.length; this.index++) {
      this.addClosers();
      this.addReopens();
      this.addOpeners();
      this.addReopens();
      this.addText();
    }
    this.addClosers();
    return this.buffer;
  },
  addReopens() {
    let entity;
    while (this.entitiesToReopen.length > 0) {
      entity = this.entitiesToReopen.pop();
      if (entity) {
        this.buffer += entity.get(this.openingHtmlProperty);
      }
    }
  },
  reopenHigherPrecedenceEntities(precedence) {
    let higherPrecedenceReopens = this.entitiesToReopen.slice(precedence).compact();
    let entity;
    while (higherPrecedenceReopens.length > 0) {
      entity = higherPrecedenceReopens.pop();
      this.buffer += entity.get(this.openingHtmlProperty);
      this.entitiesToReopen[entity.get('precedence')] = undefined;
    }
  },
  addOpeners() {
    let openers = this.openersForCurrentIndex();
    let opener;
    let precedence;
    while (openers && openers.length > 0) {
      opener = openers.pop();
      precedence = opener.get('precedence');
      if (opener) {
        this.reopenHigherPrecedenceEntities(precedence);
        this.closeLowerPrecedenceEntities(precedence);
        if (opener.get('startIndex') !== opener.get('endIndex')) {
          this.buffer += opener.get(this.openingHtmlProperty);
          this.openTags[precedence] = opener;
        }
      }
    }
  },
  addClosers() {
    let closers = this.closersForCurrentIndex();
    let closer;
    let precedence;
    while (closers && closers.length > 0) {
      closer = closers.shift();
      precedence = closer.get('precedence');
      if (closer) {
        this.closeLowerPrecedenceEntities(precedence);
        if (closer.get('startIndex') === closer.get('endIndex')) {
          this.openHigherPrecedenceEntities(precedence);
          if (!this.openTags[precedence]) {
            this.buffer += closer.get(this.openingHtmlProperty);
          }
        }
        this.buffer += closer.get(this.closingHtmlProperty);
        this.openTags[precedence] = undefined;
      }
    }
  },
  addText() {
    if (this.shouldSkipText()) {
      return;
    }
    if (this.characterAtCurrentIndex() === ' ') {
      this.addSpace();
    } else {
      let functionToCall = this.shouldEscapeContent ? 'characterAtCurrentIndexEscaped' : 'characterAtCurrentIndex';
      this.buffer += this[functionToCall]();
      this.lastCharWasNonBreakingSpace = false;
    }
  },
  addSpace() {
    if (this.shouldUseNbsp()) {
      this.buffer += '&nbsp;';
      this.lastCharWasNonBreakingSpace = true;
    } else {
      this.buffer += ' ';
      this.lastCharWasNonBreakingSpace = false;
    }
  },
  closeLowerPrecedenceEntities(precedence) {
    let lowerPrecedenceEntities = this.openTags.slice(0, precedence).compact();
    let entity;
    while (lowerPrecedenceEntities.length > 0) {
      entity = lowerPrecedenceEntities.shift();
      this.buffer += entity.get(this.closingHtmlProperty);
      this.entitiesToReopen[entity.get('precedence')] = entity;
    }
  },
  openHigherPrecedenceEntities(precedence) {
    let higherPrecedenceEntities = this.openersForCurrentIndex().slice(precedence).compact();
    let entity;
    while (higherPrecedenceEntities.length > 0) {
      entity = higherPrecedenceEntities.pop();
      if (!this.openTags[entity.get('precedence')]) {
        this.buffer += entity.get(this.openingHtmlProperty);
        this.openTags[entity.get('precedence')] = entity;
      }
    }
  },
  shouldUseNbsp() {
    if (!this.significantWhitespace) {
      return false;
    }
    if (this.lastCharWasNonBreakingSpace) {
      return this.index === this.text.length - 1;
    } else {
      return this.characterAtPreviousIndex() === ' ' || this.characterAtPreviousIndex() === '' || this.characterAtPreviousIndex() === Constants.NEW_LINE || this.index === this.text.length - 1;
    }
  },
  characterAtCurrentIndex() {
    return this.text.charAt(this.index);
  },
  characterAtPreviousIndex() {
    return this.text.charAt(this.index - 1);
  },
  characterAtCurrentIndexEscaped() {
    return htmlEscapeCharacter(this.text.charAt(this.index));
  },
  openersForCurrentIndex() {
    let entities = this.entities.get('openersByIndex')[this.index];
    if (entities) {
      return entities.compact();
    }
    return [];
  },
  closersForCurrentIndex() {
    let entities = this.entities.get('closersByIndex')[this.index];
    if (entities) {
      return entities.compact();
    }
    return [];
  },
  shouldSkipText() {
    return this.target === 'serialized' && this.openTags.any(item => item && item.get('ignoreContentsWhenSerializing'));
  }
};
export default HTMLGenerator;